export const team = [
  {
    name: 'Karin Lingg',
    id: 'karin',
    image: '',
    motivation:
      'Schmerzfreie Bewegung ist Glück und Freiheit für Körper und Geist.',
    ausbildung: [
      'Dipl Physiotherapeutin FH',
      `Dipl. Manualtherapeutin (Analytische Biomechanik nach Sohier)`,
      `Manuelle Triggerpunkttherapie MT1, MT2, MT3`,
      `Dipl. Manualtherapeutin (SAMT – Mobilisation mit und ohne Impuls)`,
      `Dipl. Sportphysiotherapeutin`,
      `Kinesiotape`,
      `Dipl. Dry Needling Therapeutin`,
      `Certified FRC Mobility Specialist (FRCms)`,
      `Fasziendistorsionsmodell FDM – Modul 1`,
      `Fasziendistorsionsmodell FDM – Modul 2`,
      `Gymnastics Injury Prevention`,
    ],
    behandlungsmethoden: [
      `Physiotherapie / Sportphysiotherapie / Rehabilitation`,
      `Manualtherapie (SAMT / Sohier)`,
      `Triggerpunkttherapie`,
      `Vitalfeldtherapie`,
      `Dryneedling`,
      `Kinesiotape`,
      `Fasziendistorsionsmodell`,
    ],
  },
  // {
  //   name: 'Manuela Kaderli',
  //   id: 'manuela',
  //   image: '',
  //   motivation:
  //     'Take care of your body. It’s the only place you have to live..',
  //   ausbildung: [
  //     'Dipl. Sportphysiotherapeutin ESP',
  //     'Physiotherapeutin FH',
  //     'Dipl. Dry Needling Therapeutin',
  //     'Eidgenössischer Fachausweis Medizinische Masseurin 2012',
  //     'Funktions- und Mobilisationsmassage, Bodyfeet AG',
  //     'Grundausbildung der DORN-Methode, Bodyfeet AG',
  //     'Leukotape Pain Relief Technique Basis, Simon Keller AG',
  //     'Kopfschmerz- und Migränetherapie, Bodyfeet AG',
  //   ],
  //   behandlungsmethoden: [
  //     'Manuelle Lymphdrainage mit Bandagierung',
  //     'Dry Needling',
  //     'Klassische Massagen',
  //     'Bindegewebsmassagen',
  //     'Fussreflexzonentherapie',
  //     'Elektrotherapie',
  //     'Funktions- und Mobilisationsmassagen',
  //     'Grundausbildung in der DORN-Methode',
  //     'Leukotape Pain Relief Technique Basis',
  //     'Kopfschmerz- und Migränetherapie',
  //   ],
  // },
  // {
  //   name: 'Marc Grob',
  //   id: 'marc',
  //   image: '',
  //   motivation: 'Ein gesunder Geist wohnt in einem gesunden Körper',
  //   ausbildung: [
  //     'Dipl. Dry Needling Therapeut',
  //     'Dipl. Physiotherapeut FH',
  //     'Fortbildung: Grundkurs Taping',
  //     'Dry Needling',
  //     'FOI',
  //   ],
  //   behandlungsmethoden: [
  //     'Physiotherapie',
  //     'Dry Needling',
  //     'Kinesiotape',
  //     'Klassische Massage',
  //   ],
  // },
  {
    name: 'Philipp Mathis',
    id: 'philipp',
    image: '',
    motivation: 'Bewegen ist Leben.',
    ausbildung: [
      'Dipl. Physiotherapeut FH',
      'Dipl. Physiotherapeut Bsc.',
      'Dry Needling Top 30',
      'Dry Needling Lower Body advanced',
      'Dry Needling Upper Body advanced',
      'Reiki Master',
      'Yoga Nidra Teacher',
    ],
    behandlungsmethoden: [
      'Dry Needling',
      'Physiotherapie',
      'Triggerpunkttherapie',
      'Manuelle Therapie',
      'Elektrotherapie',
      'Klassische Massage',
      'Taping',
      'Mobility Training',
      'Aktive Trainingstherapie',
      'Trainingslehre',
      'Yoga Nidra',
      'Reiki',
      'Schröpfen',
    ],
  },
  {
    name: 'Sibylle Eckert',
    id: 'sibylle',
    image: '',
    motivation:
      'Mein Ziel ist es, den Menschen durch Therapie und Bewegung ein Bewusstsein für ihren Körper zu geben, um ihre Ziele zu erreichen.',
    ausbildung: [
      'Dry Needling Top 30',
      'Dry Needling Lower Body Advanced',
      'Osteopathische Therapeutin',
      'Reiki Master',
      'Manuelle Therapie',
      'Craniosacrale Therapie COS',
      'Viszerale Therapie VFO',
      'Craniomadibulare Dysfunktion (Kiefer) CMD',
      'Faszienearbeit in der Osteopatischen Therapie FAO',
    ],
    behandlungsmethoden: [
      'Instruktorin für Purna Yoga',
      'Sporttherapeutin',
      'Massagetherapeutin',
      'Ernährungsberatung',
      'Elektrotherapie',
      'Trainingslehre',
      'Kinesiotaping',
    ],
  },
  {
    name: 'Muriel Williams',
    id: 'muriel',
    image: '',
    motivation:
      'Eine Reise von tausend Meilen beginnt mit einem kleinen Schritt.',
    ausbildung: [
      'Dipl. Phyisotherapeutin FH',
      'Dry Needling Top 30',
      'Dipl. Dry Needling Therapeutin',
      'Lymphdrainage',
      'Rückbildung Pilates',
      'Pilates Teacher',
    ],
    behandlungsmethoden: [
      'Lymphdrainage',
      'Triggerpunkttherapie',
      'Dry Needling',
      'Manuelle Therapie',
      'Pilates',
    ],
  },
  // {
  //   name: 'Charlotte Hohlbaum',
  //   id: 'charlotte',
  //   image: '',
  //   motivation:
  //     'Mein physiotherapeutischer Ansatz verbindet manuelle Techniken mit aktiver Therapie - immer mit Blick auf den ganzen Menschen und seine individuellen Bedürfnisse.',
  //   ausbildung: ['Dipl. Physiotherapeutin', 'i.A. Dry Needling'],
  //   behandlungsmethoden: [
  //     'Aktive und passive Physiotherapie',
  //     'Dry Needling',
  //     'Schröpfen',
  //     'Klassische Massagen',
  //     'Bindegewebsmassagen',
  //     'Manualtherapie',
  //     'Triggerpunkttherapie',
  //     'Kinesiotape',
  //     'Stosswelle',
  //   ],
  // },
  {
    name: 'Gleinner Medina',
    id: 'gleinner',
    image: 'gleinner.jpg',
    motivation:
      'Dein Wohlbefinden, mein Anliegen. Ein ganzheitlicher Ansatz zwischen emotionaler und körperlicher Gesundheit.',
    ausbildung: [
      'Diplom in Physiotherapie',
      'Masterabschluss in Osteopathie (Universitat Autònoma de Barcelona)',
      'Spezialisierung in Sportphysiotherapie',
      'Weiterbildung in Mézières-Therapie und Globaler Myofaszialer Physiotherapie',
      'Anerkennung als Physiotherapeut in der Schweiz (SRK)',
      'Fortbildungen in Dry Needling und Triggerpunkttherapie',
      'Ausbildung in Hypopressivem Training',
      'Ausbildung im Pilates Matten und Gerätebereich (Peak Pilates System)',
      'Weiterbildung in Fussreflexzonenmassage und Aromatherapie',
    ],
    behandlungsmethoden: [
      'Osteopathie',
      'Allgemeine Physiotherapie',
      'Sportphysiotherapie',
      'Rehabilitation nach Verletzungen und Operationen',
      'Behandlung von Rücken, Nacken und Gelenkschmerzen',
      'Myofasziale Therapie',
      'Triggerpunkttherapie und Dry Needling',
      'Neurologische Rehabilitation',
      'Haltungskorrektur und Bewegungsschulung',
      'Pilates Therapie',
      'Hypopressives Training',
      'Prävention und Gesundheitsförderung',
    ],
  },
  {
    name: 'Isabel Moreira da Rocha',
    id: 'isabel',
    image: 'placeholder.jpg',
    motivation:
      'Mit Bewegung, Vertrauen und Motivation gemeinsam Ziele erreichen.',
    ausbildung: ['Dipl. Physiotherapeutin BSC', 'Dry Needling Top 30 i.A'],
    behandlungsmethoden: [],
  },
  {
    name: 'Hans Ruckdäschel',
    id: 'hans',
    image: '',
    motivation:
      'Gemeinsam ans Ziel mit Empathie, Erfahrung und Kompetenz',
    ausbildung: [
      'Dipl Physiotherapeut',
      'Ödem - und Entstauungstherapeut',
      'Osteopath in Ausbildung',
      'Dry Needling Therapeut DGSA',
    ],
    behandlungsmethoden: [
      'Allgemeine Physiotherapie',
      'Manuelle Lymphdrainage',
      'Manuelle Therapie',
      'Osteopathie',
      'Dry Needling/Triggerpunkt Behandlung',
      'Funktionelles Training',
    ],
  },
]
